import React from 'react';
import Select from 'react-select';
import './FilterForm.scss';  // Import the shared styles

interface FilterOption {
  type: 'Date' | 'Choice' | 'Text' | 'Select';
  key: string;
  label: string;
  options?: { value: string; label: string }[];
  value: string | null;
  setValue: (value: string | null) => void;
  placeholder: string;
}

interface FilterFormProps {
  filters: FilterOption[];
}

const FilterForm: React.FC<FilterFormProps> = ({ filters }) => {
  const customStyles = {
    control: (provided: any, state: any) => ({
      ...provided,
      borderColor: state.isFocused ? '#f8b133' : provided.borderColor,
      '&:hover': {
        borderColor: state.isFocused ? '#f8b133' : provided.borderColor,
      },
      boxShadow: state.isFocused ? '0 0 0 0.25rem rgba(248, 177, 51, .25)' : provided.boxShadow,
    }),
    option: (provided: any, state: any) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? '#f8b133'
        : state.isFocused
          ? 'rgba(248, 177, 51, 0.75)' // 50% transparency
          : undefined,
      color: state.isSelected ? '#fff' : '#000', // Keep text black when focused/hovered
    }),
  };

  return (
    <div className="common-filter-form">
      {filters.map(filter => (
        <div key={filter.key} className="filter-group">
          <label>{filter.label}</label>
          {filter.type === 'Select' && filter.options && (
            <Select
              options={filter.options}
              value={filter.options.find(option => option.value === filter.value) || null}
              onChange={(selectedOption) => filter.setValue(selectedOption ? selectedOption.value : null)}
              placeholder={filter.placeholder}
              isClearable
              isSearchable
              styles={customStyles}
            />
          )}
          {filter.type === 'Date' && (
            <input
              type="date"
              value={filter.value ? new Date(filter.value).toISOString().split('T')[0] : ''}
              onChange={(e) => filter.setValue(e.target.value ? e.target.value : null)}
              placeholder={filter.placeholder}
            />
          )}
          {filter.type === 'Text' && (
            <input
              type="text"
              value={filter.value || ''}
              onChange={(e) => filter.setValue(e.target.value)}
              placeholder={filter.placeholder}
            />
          )}
        </div>
      ))}
    </div>
  );
};

export default FilterForm;
